import { Component, OnInit } from '@angular/core'
import { BsModalRef } from 'ngx-bootstrap/modal'
import { Subject } from 'rxjs'

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.html',
  standalone: false
})
export class ConfirmModalComponent implements OnInit {
  title = ''
  message = ''
  autoDismiss = false
  onClose: Subject<boolean>
  private timeoutId: number | undefined

  constructor(public modalRef: BsModalRef) {}

  public ngOnInit(): void {
    this.onClose = new Subject<boolean>()

    if (this.autoDismiss) {
      this.timeoutId = window.setTimeout(() => this.confirm(false), 60000)
    }
  }

  confirm(val: boolean): void {
    if (this.timeoutId) {
      window.clearTimeout(this.timeoutId)
    }
    this.modalRef.hide()
    this.onClose.next(val)
    this.onClose.complete()
  }
}
